import StringHelper from "./string-helper";
import store from "../reducers/createReducers";
import GlobalActions from "../actions/global-actions";

const color = [
    'green', 'orange', 'blue', 'purple', 'red', 'darkgreen', 'darkblue', 'pink', 'yellow',
    'sunset',
    'ocean',
    'forest',
    'purple-haze',
    'tropical',
    'candy',
    'midnight',
    'neon',
    'sunrise',
    'aqua',
    'lava',
    'berry',
    'glacier',
    'aurora',
    'flamingo',
    'mojito',
    'golden-hour',
    'royal',
    'peach',
    'sapphire',
    'mint',
    'rose',
    'amber',
    'emerald',
    'ruby',
    'coral',
    'topaz',
    'amethyst',
    'flame',
    'turquoise',
    'lemon',
    'indigo',
    'charcoal',
    'jade',
    'tangerine',
    'violet',
    'platinum',
    'onyx',
    'caramel',
    'malachite',
    'bubblegum',
    'sand',
    'gold',
    'silver',
    'bronze',
    'pearl',
    'opal'
];

const STYLE_HELPER = {
    getRandomColor() {
        const randomIndex = Math.floor(Math.random() * color.length); // Generate a random index
        return color[randomIndex]; // Return a random color from the array

        // return color[Math.floor(Math.floor(color.length % index) * color.length)];
    },
    getColorWithIndex(index) {
        return color[index % color.length];
        // return color[Math.floor(index % color?.length)];

        // return color[Math.floor(Math.floor(color.length % index) * color.length)];
    },
    setThemeButtons(configuration) {
        const darkButtons = document.querySelectorAll('.sidebar__scheme button[data-bs-theme-value="dark"]');
        const lightButtons = document.querySelectorAll('.sidebar__scheme button[data-bs-theme-value="light"]');
        const allButtons = document.querySelectorAll('.sidebar__scheme button');

        const darkButtonsSmall = document.querySelectorAll('.sidebar__scheme-small button[data-bs-theme-value="dark"]');
        const lightButtonsSmall = document.querySelectorAll('.sidebar__scheme-small button[data-bs-theme-value="light"]');
        const allButtonsSmall = document.querySelectorAll('.sidebar__scheme-small button');


        let htmlTheme = document.documentElement.getAttribute('data-bs-theme');
        document.documentElement.setAttribute('data-bs-theme', htmlTheme)

        if (htmlTheme === 'dark') {
            document.documentElement.style.setProperty('--tf-logo', `url(${configuration?.logo_white})`);
            localStorage.setItem('--tf-logo', `${configuration?.logo_white}`)


            localStorage.setItem('bg', configuration?.bg_dark)

            document.documentElement.style.setProperty('--tf-logo2', `url(${configuration?.logo_gray})`);
            document.documentElement.style.setProperty('--tf-bg', `${configuration?.bg_dark}`);
            document.documentElement.style.setProperty('--tf-bg2', `${configuration?.bg2_dark}`);
            document.documentElement.style.setProperty('--tf-skeleton', StringHelper.hexToRgba(configuration?.bg_dark, .4));

            document.documentElement.style.setProperty('--mini-logo', `url(${configuration?.mini_logo || configuration?.mini_logo_dark})`);

            let themeMetaTag = document.querySelector('meta[name="theme-color"]');
            if (themeMetaTag) {
                themeMetaTag.setAttribute('content', configuration?.bg2_dark);
            } else {
                themeMetaTag = document.createElement('meta');
                themeMetaTag.name = 'theme-color';
                themeMetaTag.content = configuration?.bg2_dark;
                document.head.appendChild(themeMetaTag);
            }

            allButtons.forEach(button => button.classList?.remove('active'));
            darkButtons.forEach(button => button.classList?.add('active'));
            allButtonsSmall.forEach(button => button.classList?.remove('active'));
            darkButtonsSmall.forEach(button => button.classList?.add('active'));
        } else {

            localStorage.setItem('bg', configuration?.bg_light)
            document.documentElement.style.setProperty('--tf-logo', `url(${configuration?.logo_dark})`);
            localStorage.setItem('--tf-logo', `${configuration?.logo_dark}`)

            document.documentElement.style.setProperty('--mini-logo', `url(${configuration?.mini_logo_dark || configuration?.mini_logo})`);


            document.documentElement.style.setProperty('--tf-logo2', `url(${configuration?.logo_gray})`);
            document.documentElement.style.setProperty('--tf-bg', `${configuration?.bg_light}`);
            document.documentElement.style.setProperty('--tf-bg2', `${configuration?.bg2_light}`);
            document.documentElement.style.setProperty('--tf-skeleton', StringHelper.hexToRgba(configuration?.bg_light, .4));


            let themeMetaTag = document.querySelector('meta[name="theme-color"]');
            if (themeMetaTag) {
                themeMetaTag.setAttribute('content', configuration?.bg2_light);
            } else {
                themeMetaTag = document.createElement('meta');
                themeMetaTag.name = 'theme-color';
                themeMetaTag.content = configuration?.bg2_light;
                document.head.appendChild(themeMetaTag);
            }


            allButtons.forEach(button => button.classList?.remove('active'));
            lightButtons.forEach(button => button.classList?.add('active'));
            allButtonsSmall.forEach(button => button.classList?.remove('active'));
            lightButtonsSmall.forEach(button => button.classList?.add('active'));
        }

        // console.log('htmlTheme = ', htmlTheme)
        store.dispatch(GlobalActions.setThemeAction(htmlTheme))
    }

}

export default STYLE_HELPER
